import { render, staticRenderFns } from "./NotificationsTypeCountPieChart.vue?vue&type=template&id=8be9856e&scoped=true&"
import script from "./NotificationsTypeCountPieChart.vue?vue&type=script&lang=js&"
export * from "./NotificationsTypeCountPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be9856e",
  null
  
)

export default component.exports